import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  addOrUpdateImageDocument,
  removeImageDocumentFromSpecificContext,
  setNotSubmittedDeletedImage,
} from '../imageHandlingV2.slice';
import { pushMessage } from '@reducers/v2/messagesBus/messagesBus.slice';
import { Alert } from '@helpers';
import { backendCall, createApiCall } from '@reducers/utils';
import type { RootState, AppDispatch } from '@store/types';
import { ImageContext, ImageDocumentStoreItem } from '@v2/components/imageHandling/types/types';
import { ImageDocumentMessageType } from '@reducers/v2/messagesBus/types';
import { trackEvent, TRACKING_EVENTS } from '@services/tracking';

export interface RemoveImageDocumentPayload {
  documentId: number;
  imageContext: ImageContext;
  imageDocument: ImageDocumentStoreItem;
}

export const removeImageDocument = createAsyncThunk<void, RemoveImageDocumentPayload, { state: RootState; dispatch: AppDispatch }>(
  'imageHandlingV2/removeImageDocument',
  async (payload, { dispatch }) => {
    const { documentId, imageContext, imageDocument } = payload;

    //save image for restoring purpose - save both document and context
    dispatch(setNotSubmittedDeletedImage({ document: imageDocument, imageContext }));

    // optimistic update
    dispatch(removeImageDocumentFromSpecificContext({ documentId, imageContext }));

    await dispatch(
      backendCall(
        createApiCall((api) => api.imageHandling.removeImage, {
          params: { documentId },
          onSuccess: async () => {
            trackEvent(TRACKING_EVENTS.DOCUMENT, { action: 'deleted' });
            dispatch(
              pushMessage({
                key: documentId,
                message: {
                  messageType: ImageDocumentMessageType.IMAGE_DELETED,
                  payload: {
                    documentId,
                    local: true,
                  },
                },
              })
            );
          },
          onError: () => {
            Alert({ title: 'Error during deleting the image. Please, try again.' });
            // reverting optimistic update
            dispatch(addOrUpdateImageDocument({ document: imageDocument, imageContext }));
          },
        })
      )
    );
  }
);
